import React, { useEffect, useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";

import Modal from "../../../components/Modal";
import Button from "../../../components/Button";
import InputDate from "../../../components/InputDate";
import InputSelect from "../../../components/InputSelect";

import api from "../../../services/api";
import { renderError } from "../../../helpers/errors";

const TITLES = {
    reopen: 'Definir como em aberto',
    change_due_date: 'Alterar data prevista',
    change_account: 'Alterar conta',
};

// O backend nunca falha em silêncio: devolve quem mudou e quem ficou de fora,
// com o motivo. A tela repete isso em vez de só dizer "pronto".
const reportResult = ({ updated, ignored }) => {
    if (updated > 0) {
        toast.success(`${updated} ${updated === 1 ? 'título atualizado' : 'títulos atualizados'}`);
    }

    if (ignored.length > 0) {
        const reasons = [...new Set(ignored.map(item => item.reason))].join('; ');
        toast.warning(`${ignored.length} ${ignored.length === 1 ? 'título ignorado' : 'títulos ignorados'}: ${reasons}`);
    }
};

export const ModalBatchAction = ({ action, entryIds, bankAccounts, close, onSaved }) => {
    const [saving, setSaving] = useState(false);
    const [dueDate, setDueDate] = useState('');
    const [bankAccountId, setBankAccountId] = useState(null);

    useEffect(() => {
        if (!action) return;

        setDueDate(moment().format('YYYY-MM-DD'));
        setBankAccountId(null);
    }, [action]);

    const save = () => {
        setSaving(true);

        api.post(`/finance-entry/batch`, {
            action,
            ids: entryIds,
            due_date: action === 'change_due_date' ? dueDate : null,
            finance_bank_account_id: action === 'change_account' ? bankAccountId : null,
        }).then(res => {
            reportResult(res.data.resource);
            close();
            onSaved();
        }).catch(renderError).then(() => setSaving(false));
    };

    const count = entryIds.length;
    const titles = `${count} ${count === 1 ? 'título selecionado' : 'títulos selecionados'}`;
    const disabled = (action === 'change_due_date' && !dueDate) || (action === 'change_account' && !bankAccountId);

    return (
        <Modal
            title={TITLES[action] ?? ''}
            show={action !== null}
            close={close}
            footer={<Button type={`primary`} size={`small`} text={`Confirmar`} action={save} loading={saving} disabled={disabled} />}
        >
            <div className="section">
                {action === 'reopen' &&
                    <p>
                        As baixas dos {titles} serão estornadas e eles voltam a ficar em aberto.
                        Títulos com baixa conciliada com o extrato bancário ficam de fora — esses se desfazem pela conciliação.
                    </p>
                }
                {action === 'change_due_date' &&
                    <>
                        <p>Nova data de vencimento para os {titles}. Títulos já quitados ficam como estão.</p>
                        <InputDate label={`Data prevista`} format={`YYYY-MM-DD`} value={dueDate} change={setDueDate} />
                    </>
                }
                {action === 'change_account' &&
                    <>
                        <p>Nova conta prevista para os {titles}. Baixas já realizadas não mudam de conta.</p>
                        <InputSelect
                            label={`Conta`}
                            options={bankAccounts.map(account => ({ label: account.name, value: account.id }))}
                            value={bankAccountId}
                            change={setBankAccountId}
                        />
                    </>
                }
            </div>
        </Modal>
    );
};

export default ModalBatchAction;
